export const COURSE_PAUSE_REQUEST_TABS = [
  {
    name: 'Requested',
    to: '/requested',
  },
  {
    name: 'Pending',
    to: '/pending',
  },
  {
    name: 'Approved',
    to: '/approved',
  },
  {
    name: 'To be Resumed',
    to: '/to-be-resumed',
  },
  {
    name: 'Scheduled',
    to: '/scheduled',
  },
];
